import { Component, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavParams } from '@ionic/angular';
import { APIService } from 'src/providers/apiservices/apiservices';
import { Events } from 'src/providers/apiservices/eventsservice';
import {
  GlobalService
} from 'src/providers/apiservices/globalservices';
import { LocalStorageProvider } from 'src/providers/apiservices/localstorageprovider';
import { ContratoProvider } from 'src/providers/contrato/contrato';
import { EmpresaProvider } from 'src/providers/empresa/empresa';
import {
  SelectSearchableItem,
  SelectSearchablePage,
} from '../select-searchable/select-searchable.page';
import { lastDayOfMonth, subMonths } from 'date-fns';

@Component({
  selector: 'app-escolherempresacontrato',
  templateUrl: './escolherempresacontrato.page.html',
  styleUrls: ['./escolherempresacontrato.page.scss'],
})
export class EscolherempresacontratoPage implements OnInit {
  malls = [];
  stores = [];

  shoppingConfig: string = '';
  lojaConfig: string = '';
  menu: string = '';
  
  isAutorizacao: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private loadingController: LoadingController,
    private empresaProvider: EmpresaProvider,
    private globalService: GlobalService,
    private contratoProvider: ContratoProvider,
    public navParams: NavParams,
    private localStorageProvider: LocalStorageProvider,
    private events: Events,
  ) {
    this.shoppingConfig = navParams.get('shopping') + '';
    this.lojaConfig = navParams.get('loja') + '';
    this.menu = navParams.get('nomeMenu') + '';

    if (this.menu === 'autorizacao') {
      this.isAutorizacao = true;
    }
  }

  ngOnInit() {
    this.carregarEmpresas();
  }

  dismiss() {
    this.modalCtrl.dismiss({
      'shoppingTexto': this.textoShoppingFiltrando,
      'shoppingCod': this.filtroLojistaShopping,
      'loja': this.lojaSelecionadaFiltro,
      'numContrato': this.numContratoSelecionado
    });
  }

  onClick() {
    let configUser = this.localStorageProvider.getUserConfig(
      APIService.UsuarioLogado.Usuario.login1
    );

    configUser.shoppingTexto = this.textoShoppingFiltrando;
    configUser.shoppingCod = this.filtroLojistaShopping;

    if (this.lojaSelecionadaFiltro != 'Administração') {
      configUser.loja = this.lojaSelecionadaFiltro;
      configUser.numContrato = this.numContratoSelecionado;
    }
    configUser.tipoUsuario = APIService.UsuarioLogado?.Usuario?.idTipoUsuario;
    configUser.dataToken = APIService.UsuarioLogado?.dataToken
    configUser.token = APIService.UsuarioLogado?.TOKENJWT

    this.globalService.devlog("USUARIO", APIService.UsuarioLogado.Usuario);

    if(!configUser.shoppingCod)
    {
      configUser.numContrato = '';
      configUser.loja = '';
    }

    this.localStorageProvider.saveUserConfig(configUser);

    this.events.publish('communication.getComunicados', {});

    if (this.lojaSelecionadaFiltro != 'Administração') {
      this.events.publish('authorization.getAutorizacoes', {});
    }
    
    this.events.publish('home.refreshData', {});

    this.events.publish('report.refreshData', {});

    this.events.publish('shops.refreshData', {});

    this.events.publish('shoppingcontratos.refreshData', {});

    this.events.publish('users.refreshData', {});

    this.events.publish('app.refreshData', {});

    this.events.publish('dashboardmulti.refreshData', {});

    this.events.publish('formbeneficios.refreshData', {});


    this.dismiss();

    // if (this.textoShoppingFiltrando == '') {
    //   this.globalService.presentToast(
    //     'É preciso selecionar um shopping.',
    //     ToastColors.danger
    //   );
    // } else {
    //   configUser.shoppingTexto = this.textoShoppingFiltrando;
    //   configUser.shoppingCod = this.filtroLojistaShopping;
    //   configUser.loja = this.lojaSelecionadaFiltro;
    //   configUser.numContrato = this.numContratoSelecionado;
    //   configUser.tipoUsuario = APIService.UsuarioLogado?.Usuario?.idTipoUsuario;
    //   configUser.dataToken = APIService.UsuarioLogado?.dataToken
    //   configUser.token = APIService.UsuarioLogado?.TOKENJWT

    //   this.globalService.devlog("USUARIO", APIService.UsuarioLogado.Usuario);

    //   this.localStorageProvider.saveUserConfig(configUser);

    //   this.events.publish('communication.getComunicados', {});

    //   this.events.publish('authorization.getAutorizacoes', {});

    //   this.events.publish('home.refreshData', {});

    //   this.events.publish('report.refreshData', {});

    //   this.events.publish('shops.refreshData', {});

    //   this.events.publish('shoppingcontratos.refreshData', {});

    //   this.dismiss();
    // }
  }

  lojaSelecionadaFiltro: string = '';
  numContratoSelecionado: string = '';
  textoShoppingFiltrando: string = '';
  filtroLojistaShopping: string = '';
  dataAberturaLoja: string = '';
  dataAberturaAdm: string = '';

  async openShoopingsModal() {
    let lista: Array<SelectSearchableItem> = [];
    let listaFiltro: Array<SelectSearchableItem> = [];

    // remover duplicados por idEmpresa
    const mallsUnicos = Array.from(
      new Map(this.malls.map(m => [m.nomEmpresa, m])).values()
    );

    mallsUnicos.forEach((shopping) => {
      let item: SelectSearchableItem = new SelectSearchableItem(
        shopping.idEmpresa,
        `${shopping.nomEmpresa}`,
        shopping.nomEmpresa
      );
      lista.push(item);
    });

    if (this.filtroLojistaShopping != '') {
      let item: SelectSearchableItem = new SelectSearchableItem(
        this.filtroLojistaShopping,
        this.textoShoppingFiltrando,
        this.textoShoppingFiltrando
      );
      listaFiltro.push(item);
    }

    const modal = await this.modalCtrl.create({
      component: SelectSearchablePage,
      componentProps: {
        titulo: 'Shoppings',
        filtro: '',
        lista: lista,
        maxsize: 1,
        selecionados: listaFiltro,
      },
      cssClass: 'modal-edicao',
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((ret) => {
      if (ret.data && ret.data.salvar) {
        ////console.log('selecionados: ', ret.data.selecionados);
        this.filtroLojistaShopping = '';

        if (ret.data.selecionados.length > 0) {
          console.log(ret.data.selecionados)
          for (let i = 0; i < ret.data.selecionados.length; i++) {
            let loja = {
              value: ret.data.selecionados[i].id,
              texto: ret.data.selecionados[i].texto,
            };

            var mallObj = this.malls.find(mall => mall.idEmpresa == loja.value);

            // Limpar loja selecionada caso shopping seja diferente do anterior selecionado
            if(this.textoShoppingFiltrando != loja.texto && this.filtroLojistaShopping != loja.value)
            {
              this.lojaSelecionadaFiltro = ''
              this.numContratoSelecionado = ''
              this.dataAberturaAdm = '';
              this.dataAberturaLoja = '';
            }

            this.textoShoppingFiltrando = loja.texto;
            this.filtroLojistaShopping = loja.value;
            this.dataAberturaAdm = mallObj?.dtAberturaAdm;
            this.dataAberturaLoja = mallObj?.dtAberturaLoja;
          }
        } else {
          this.filtroLojistaShopping = '';
          this.textoShoppingFiltrando = '';
          this.lojaSelecionadaFiltro = '';
          this.dataAberturaAdm = '';
          this.dataAberturaLoja = '';
        }

        this.selecionarEmpresa();
      }
    });

    //load.dismiss();
    await modal.present();
  }

  async openLojasModal() {
    let lista: Array<SelectSearchableItem> = [];
    let listaFiltro: Array<SelectSearchableItem> = [];

    const loginPerfis = APIService.UsuarioLogado?.Usuario?.contratoLoginPerfils;

    let todasLojas = loginPerfis.find(
      (perfil) =>
        perfil.numContrato === 'TODOS_TODS' || perfil.numContrato === 'TODS'
    );


    let configUser = this.localStorageProvider.getUserConfig(
      APIService.UsuarioLogado.Usuario.login1
    );

    if(this.numContratoSelecionado == '')
    {
      this.numContratoSelecionado = configUser.numContrato
    }

    if (todasLojas) {
      lista = this.stores.map(loja => {

        let item: SelectSearchableItem = new SelectSearchableItem(
          loja.numContrato,
          `${loja.nomContrato} (${loja.lucLoja} - ${loja.numContrato})`,
          loja.numContrato
        );

        if(loja.numContrato == this.numContratoSelecionado)
        {
          item.isVisivel = false;
        }

        return item;
      })

      if (this.isAutorizacao) {
        let item: SelectSearchableItem = new SelectSearchableItem(
          'admin',
          'Administração',
          'admin'
        );

        lista.push(item);
      }
    } else {
      const _filteredStores = this.stores.filter(x => x.numContrato == configUser.numContrato);

      lista = _filteredStores.map(loja => {

        let item: SelectSearchableItem = new SelectSearchableItem(
          loja.numContrato,
          `${loja.nomContrato} (${loja.lucLoja} - ${loja.numContrato})`,
          loja.numContrato
        );

        if(loja.numContrato == this.numContratoSelecionado)
        {
          item.isVisivel = false;
        }

        return item;
      })


      if (this.isAutorizacao) {
        let item: SelectSearchableItem = new SelectSearchableItem(
          'admin',
          'Administração',
          'admin'
        );

        lista.push(item);
      }
    }


    if (this.lojaSelecionadaFiltro != '') {
      let item: SelectSearchableItem = new SelectSearchableItem(
        this.numContratoSelecionado,
        this.lojaSelecionadaFiltro,
        this.numContratoSelecionado
      );
      listaFiltro.push(item);
    }

    const modal = await this.modalCtrl.create({
      component: SelectSearchablePage,
      componentProps: {
        titulo: 'Lojas de ' + this.textoShoppingFiltrando,
        filtro: '',
        lista: lista,
        maxsize: 1,
        selecionados: listaFiltro,
      },
      cssClass: 'modal-edicao',
      backdropDismiss: false,
    });

    modal.onDidDismiss().then((ret) => {
      if (ret.data && ret.data.salvar) {
        ////console.log('selecionados: ', ret.data.selecionados);
        this.lojaSelecionadaFiltro = '';
        this.numContratoSelecionado = '';

        if (ret.data.selecionados.length > 0) {
          for (let i = 0; i < ret.data.selecionados.length; i++) {
            // let loja = {
            //   "value": ret.data.selecionados[i].texto
            // };
            this.lojaSelecionadaFiltro = ret.data.selecionados[i].texto;
            this.numContratoSelecionado = ret.data.selecionados[i].id;
          }
        } else {
          this.lojaSelecionadaFiltro = '';
          this.numContratoSelecionado = '';
          this.dataAberturaAdm = '';
          this.dataAberturaLoja = ''
        }
      }
    });

    //load.dismiss();
    await modal.present();
  }

  /** ACESSANDO DADOS REMOTOS  */
  async selecionarEmpresa() {
    if (this.filtroLojistaShopping == '') {
      this.stores = [];
    } else {
      let loading = await this.loadingController.create({
        message: 'Aguarde...',
      });
      loading.present();
      //var cpf = this.form_login.controls["usuario"].value.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");;
      this.contratoProvider
        .get(this.filtroLojistaShopping, '', false)
        .then((response) => {
          var temp = [];
          loading.dismiss();
          temp.push(response);
          if (temp[0].Item) {
            this.stores = temp[0].Item;
            //this.globalService.publishToast({Mensagem:`Um email com um link para redefinir a senha foi enviado para o seu email (${email}), favor verificar.`, Severidade:1, Posicao:"top"  });

            let configUser = this.localStorageProvider.getUserConfig(
              APIService.UsuarioLogado.Usuario.login1
            );

            var lastDayOfPastMonth = lastDayOfMonth(subMonths(new Date(), 1));
            if (configUser.isUsuarioMultiplan) {
              //this.stores = this.stores.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) > lastDayOfPastMonth || new Date(store.dtRescisao) > new Date(this.dataAberturaAdm))
              this.stores = this.stores.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) >= new Date(this.dataAberturaAdm))
            } else {
              //this.stores = this.stores.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) > lastDayOfPastMonth || new Date(store.dtRescisao) > new Date(this.dataAberturaLoja))
              this.stores = this.stores.filter(store => store.dtRescisao == null || new Date(store.dtRescisao) >= new Date(this.dataAberturaLoja))
            }


            this.stores.forEach((loja) => {
              if (
                `${loja.nomContrato} (${loja.lucLoja} - ${loja.numContrato})` == this.lojaConfig
              ) {
                this.lojaSelecionadaFiltro = this.lojaConfig;
                this.numContratoSelecionado = loja.numContrato;
              }
            });
          } else {
            this.globalService.publishToast({
              Mensagem: temp[0].erro,
              Severidade: 2,
              Posicao: 'top',
            });
          }
        })
        .catch((error: any) => {
          this.globalService.publishToast({
            Mensagem: error.erro,
            Severidade: 2,
            Posicao: 'top',
          });
          loading.dismiss();
        });
    }
  }

  async carregarEmpresas() {
    let loading = await this.loadingController.create({
      message: 'Aguarde...',
    });
    loading.present();
    this.empresaProvider
      .get('')
      .then((response) => {
        var temp = [];
        loading.dismiss();
        temp.push(response);
        if (temp[0].Item) {
          this.malls = temp[0].Item;

          const loginPerfis =
            APIService.UsuarioLogado?.Usuario?.contratoLoginPerfils;

          const todasEmpresas = loginPerfis.find(
            (perfil) => perfil.idEmpresa === 'TODS'
          );

          // Caso o usuário tenha acesso a todas as empresas, não filtra.
          if (!todasEmpresas) {
            this.malls = loginPerfis
              .filter((perfil) => perfil.empresa)
              .map((perfil) => perfil.empresa);
          }

          this.malls.forEach((shopping) => {
            if (shopping.idEmpresa == this.shoppingConfig) {
              this.textoShoppingFiltrando = shopping.nomEmpresa;
              this.filtroLojistaShopping = shopping.idEmpresa;
              this.dataAberturaAdm=shopping.dtAberturaAdm;

              this.selecionarEmpresa();
            }
          });
        } else {
          this.globalService.publishToast({
            Mensagem: temp[0].erro,
            Severidade: 2,
            Posicao: 'top',
          });
        }
      })
      .catch((error: any) => {
        this.globalService.publishToast({
          Mensagem: error.erro,
          Severidade: 2,
          Posicao: 'top',
        });
        loading.dismiss();
      });
  }
}
